import React from 'react';

import { Icon, InputAdornment } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { omit } from 'lodash';

import TextField, { TextFieldProps } from '../TextField';

const styles = () => ({
  closeIcon: {
    cursor: 'pointer',
  },
});

export interface TextFieldSearchProps extends Omit<TextFieldProps, 'onChange'> {
  classes: any;
  className?: string;
  onChange?: (v: string) => void;
}

const TextFieldSearch: React.FC<TextFieldSearchProps> = ({
  classes,
  value,
  size = 'default',
  onChange = () => undefined,
  ...other
}) => (
  <TextField
    size={size}
    value={value}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Icon fontSize={size}>search</Icon>
        </InputAdornment>
      ),
      endAdornment: (
        <InputAdornment position="end">
          {!!value && (
            <Icon className={classes.closeIcon} fontSize={size} onClick={() => onChange('')}>
              close
            </Icon>
          )}
        </InputAdornment>
      ),
      ...other.InputProps,
    }}
    onChange={(event: any) => onChange(event.target.value)}
    {...omit(other, 'InputProps')}
  />
);

export default withStyles(styles)(TextFieldSearch);
